export default __webpack_public_path__ + "static/media/Layer 32.d4f26d66.jpg";